/**
 * T-09 · La verificación del código, contra Supabase **directamente**.
 *
 * `Q-18`: NestJS ve el teléfono y **nunca el código**. Se sostiene porque el
 * código viaja del SMS al navegador y del navegador a Supabase, sin pasar por
 * nuestro servidor en ningún momento.
 *
 * ── La llave que va aquí es la PUBLICABLE, y está bien que lo sea ───────────
 * Acaba dentro del JavaScript que descarga cualquiera; es pública por diseño y
 * no permite nada que las policies no permitan. **La secreta jamás baja al
 * navegador**: vive sólo en el servicio de la API.
 */
import { ErrorParaLaPantalla } from './errores.js';
import { createClient } from '@supabase/supabase-js';
function cliente() {
    const url = import.meta.env['VITE_SUPABASE_URL'];
    const llave = import.meta.env['VITE_SUPABASE_LLAVE_PUBLICABLE'];
    if (!url || !llave) {
        //  Un `Error` pelado A PROPÓSITO: esto es para quien despliega, y por eso
        //  NO es `ErrorParaLaPantalla`. El 2026-09-25 se vio en la pantalla de un
        //  comensal, y lo que lo dejó pasar fue un `instanceof Error`.
        throw new Error('Faltan VITE_SUPABASE_URL y/o VITE_SUPABASE_LLAVE_PUBLICABLE. Es la llave ' +
            'publicable (sb_publishable_…), NUNCA la secreta: ésta acaba dentro del ' +
            'JavaScript que descarga cualquiera.');
    }
    return createClient(url, llave, {
        auth: {
            // No se guarda nada: la sesión de este panel es **nuestra cookie**, no la
            // de Supabase. Dejar que persista su token en `localStorage` crearía una
            // segunda sesión, con otra vida y sin forma de revocarla desde T-05.
            persistSession: false,
            autoRefreshToken: false,
        },
    });
}
/**
 * Devuelve el token ya verificado, para cambiarlo por nuestra cookie.
 *
 * ── `TelefonoE164` y no `string`, y es lo que arregla un fallo de `F2` ────
 * Supabase verifica el par **(teléfono, código)**. Si aquí llega lo que la
 * persona tecleó —«662 467 4951»— y la API pidió el código para
 * `+526624674951`, la búsqueda no encuentra nada y contesta «caducado o
 * inválido» con el código recién llegado y correcto. El panel hacía exactamente
 * eso, y por eso nadie podía entrar.
 *
 * El tipo lo impide: sólo `normalizarTelefono` fabrica un `TelefonoE164`.
 */
export async function verificarCodigo(telefono, codigo) {
    const { data, error } = await cliente().auth.verifyOtp({
        phone: telefono, token: codigo, type: 'sms',
    });
    if (error || !data.session) {
        // Sin detalle: distinguir «código malo» de «caducado» le dice a quien prueba
        // en qué se acercó.
        //  `ErrorParaLaPantalla` y no un `Error` pelado: esta frase está escrita
        //  para el comensal, y el tipo es lo único que lo distingue del error de
        //  configuración de arriba — que NUNCA debe verse.
        throw new ErrorParaLaPantalla('Ese código no funcionó. Revísalo o pide uno nuevo.');
    }
    return data.session.access_token;
}
//# sourceMappingURL=supabase.js.map